import React__default from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-hot-toast';
import { Button } from '../Button/Button.js';
import { ButtonGroup } from '../ButtonGroup/ButtonGroup.js';

var ToastType;
(function (ToastType) {
    ToastType["positive"] = "Toast__positive";
    ToastType["negative"] = "Toast__negative";
    ToastType["alert"] = "Toast__alert";
    ToastType["info"] = "Toast__info";
})(ToastType || (ToastType = {}));
const getIcon = (props) => {
    switch (props.type) {
        case ToastType.positive:
            return 'check-circle';
        case ToastType.negative:
        case ToastType.alert:
            return 'exclamation-triangle';
        case ToastType.info:
            return 'info-circle';
        default:
            return 'check-circle'; // fallback
    }
};
const dismissToast = (toastId) => {
    toast.dismiss(toastId);
};
const Toast = (props) => {
    var _a, _b;
    const iconName = getIcon(props);
    let buttons;
    if (props.buttons && props.buttons.length) {
        buttons = props.buttons.map((button, index) => (React__default.createElement(Button, Object.assign({ key: index, type: 'primary', size: 'small', handleClick: button.clickHandler }, button.buttonProps), button.text)));
    }
    const handleClick = () => {
        dismissToast(props.state.id);
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            dismissToast(props.state.id);
        }
    };
    return (React__default.createElement("div", { className: `Toast ${props.type} Toast__regular ${props.state.visible ? 'animateEnter' : 'animateExit'}`, role: 'complementary' },
        React__default.createElement("div", { className: 'Toast__text' },
            React__default.createElement(FontAwesomeIcon, { icon: iconName }),
            typeof props.message === 'string' && React__default.createElement("span", null, props.message),
            typeof props.message === 'object' && (React__default.createElement("div", { className: (_a = props.message) === null || _a === void 0 ? void 0 : _a.className },
                React__default.createElement("span", { className: 'Toast__title', "data-testid": 'title' }, props.message.title),
                React__default.createElement("span", { "data-testid": 'body' }, props.message.body)))),
        !!((_b = props.buttons) === null || _b === void 0 ? void 0 : _b.length) && React__default.createElement(ButtonGroup, null, buttons),
        props.requireDismissal && (React__default.createElement("button", { className: 'Toast__close', onClick: handleClick, onKeyDown: handleKeyDown },
            React__default.createElement(FontAwesomeIcon, { icon: 'times' })))));
};
const displayToast = (message, type, requireDismissal, duration = 5000, buttons) => {
    const toastId = toast.custom((toastState) => (React__default.createElement(Toast, { state: toastState, message: message, type: type, requireDismissal: requireDismissal, buttons: buttons })), { duration: requireDismissal ? Infinity : duration });
    return toastId;
};

export { Toast, ToastType, dismissToast, displayToast, getIcon };
//# sourceMappingURL=Toast.js.map
